import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Custom icon button (e.g., play/pause) to overlay on the video */
  iconButton: PropTypes.node.isRequired,
  /** Array of video source objects for different formats/resolutions */
  sources: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })).isRequired,
  /** Position of the icon button overlay */
  buttonPosition: PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
  /** Additional video attributes and controls. See below for details */
  videoControls: PropTypes.shape({
    autoPlay: PropTypes.bool,
    loop: PropTypes.bool,
    playsInline: PropTypes.bool,
    poster: PropTypes.string,
    preload: PropTypes.string,
    ref: PropTypes.oneOfType([PropTypes.func,
    /**
     * Looking for the best way to do this-- please see note on SSR here:
     * https://stackoverflow.com/questions/48007326/what-is-the-correct-proptype-for-a-ref-in-react/51127130#51127130
     */
    // eslint-disable-next-line react/forbid-prop-types
    PropTypes.shape({
      current: PropTypes.any
    })])
  })
};
function Video(_ref) {
  var buttonPosition = _ref.buttonPosition,
    iconButton = _ref.iconButton,
    sources = _ref.sources,
    _ref$videoControls = _ref.videoControls,
    _ref$videoControls2 = _ref$videoControls === void 0 ? {} : _ref$videoControls,
    autoPlay = _ref$videoControls2.autoPlay,
    loop = _ref$videoControls2.loop,
    playsInline = _ref$videoControls2.playsInline,
    poster = _ref$videoControls2.poster,
    preload = _ref$videoControls2.preload,
    ref = _ref$videoControls2.ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "video",
    "data-button-position": buttonPosition,
    "data-testid": "videoWrapper"
  }, /*#__PURE__*/React__default.createElement("video", {
    "data-testid": "videoElement",
    autoPlay: autoPlay,
    loop: loop,
    muted: true,
    poster: poster,
    ref: ref,
    playsInline: playsInline,
    preload: preload
  }, sources.map(function (_ref2) {
    var key = _ref2.key,
      src = _ref2.src,
      type = _ref2.type;
    return /*#__PURE__*/React__default.createElement("source", {
      "data-testid": key,
      key: key,
      src: src,
      type: type
    });
  })), iconButton);
}
Video.propTypes = propTypes;

export { Video as default };
//# sourceMappingURL=Video.js.map
